import React, { useState, useEffect } from "react";
import axios from "axios";
import TableOne from "../Table/TableOne"; // Import your table component
import Modal from "react-modal";
import "./../style/common.css";
import "./../Table/table.css";
import "./../style/pop-up.css";
import { CiWarning } from "react-icons/ci";
import {
  TextField,
  MenuItem,
  Radio,
  RadioGroup,
  FormHelperText,
} from "@mui/material";
import {
  FaUserTie,
  FaUser,
  FaAddressCard,
  FaCity,
  FaSearch,
} from "react-icons/fa";
import { MdEmail, MdBadge } from "react-icons/md";
import { TbMapPinCode } from "react-icons/tb";
import { RiLockPasswordFill } from "react-icons/ri";
import { SlOrganization } from "react-icons/sl";
import { FaMobileRetro, FaTreeCity } from "react-icons/fa6";
import { InputAdornment } from "@mui/material";
import { GiWorld } from "react-icons/gi";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Manager = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [department, setDepartment] = useState([]);
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [errors, setErrors] = useState({}); //error show state
  const [filteredManager, setFilteredManager] = useState([]); // For search functionality 
  const [managerProfile, setManagerProfile] = useState(
    "../images/imageicon.png"
  ); // State to store profile image
  const [showDeleteEmployeeBox, setShowDeleteEmployeeBox] = useState(false);
  const [deleteEmployeeName, setDeleteEmployeeName] = useState("");
  const [deleteEmployeeId, setDeleteEmployeeId] = useState(null);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [selectedEmployeeName, setSelectedEmployeeName] = useState("");

  const [formData, setFormData] = useState({
    employee_first_name: "",
    employee_middle_name: "",
    employee_last_name: "",
    employee_email: "",
    employee_password: "",
    employee_gender: "",
    employee_contact: "",
    employee_dept_id: "",
    employee_type: "",
    employee_dateofjoin: "",
    employee_country: "",
    employee_state: "",
    employee_city: "",
    employee_address: "",
    employee_pincode: "",
    employee_profile: "",
    employee_role: "M",
    employee_islastlogin: "",
    employee_dateofleave: "",
    employee_isactive: false,
    employee_attachfile: "",
  });
  const [imageUrl, setImageUrl] = useState(null); // State to store the selected image URL
  const [editMode, setEditMode] = useState(false);

  // Handle file input change
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Create a URL for the uploaded image file
      const newImageUrl = URL.createObjectURL(file);
      console.log("newImageUrl-->", newImageUrl);
      const showImage = URL.revokeObjectURL(imageUrl);
      console.log("showImage-->", showImage);

      setImageUrl(newImageUrl);
    }
  };

  // Fetch Department data from the API
  const fetchDepartment = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://aligndesk.dropyourbusiness.com/api/dept"
      );
      const deptData = response.data.department.map((dept) => ({
        DepartmentId: dept.department_id,
        DepartmentName: dept.department_name,
        DepartmentIsActive: dept.department_isactive,
      }));
      console.log("department-->", deptData.DepartmentName);
      setDepartment(deptData);
    } catch (error) {
      console.error("Error fetching department data:", error);
      //   toast.error("Error fetching employee data.");
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchDepartment();
  }, []);

  // Fetch Country data from the API
  const fetchCountry = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://aligndesk.dropyourbusiness.com/api/countries"
      );
      const countryData = response.data.data.map((country) => ({
        CountryId: country.id,
        CountryName: country.name,
      }));
      console.log("countryData-->", country);
      setCountry(countryData);
    } catch (error) {
      console.error("Error fetching country data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchCountry();
  }, []);

  // Fetch State data based on selected Country
  const fetchState = async (countryId) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://aligndesk.dropyourbusiness.com/api/states/${countryId}`
      );
      console.log("stateData-->", response.data);
      const stateData = response.data.data.map((state) => ({
        StateId: state.id,
        StateName: state.name,
      }));
      console.log("stateData-->", stateData);

      setState(stateData);
      setCity([]); // Clear cities when country or state changes
    } catch (error) {
      console.error("Error fetching state data:", error);
    }
    setLoading(false);
  };

  // Fetch City data based on selected State
  const fetchCity = async (stateId) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://aligndesk.dropyourbusiness.com/api/cities/${stateId}`
      );
      const cityData = response.data.data.map((city) => ({
        CityId: city.id,
        CityName: city.name,
      }));
      setCity(cityData);
    } catch (error) {
      console.error("Error fetching city data:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (formData.employee_country) {
      fetchState(formData.employee_country);
    }
  }, [formData.employee_country]);

  useEffect(() => {
    if (formData.employee_state) {
      fetchCity(formData.employee_state);
    }
  }, [formData.employee_state]);

  // Fetch employee data from the API
  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://aligndesk.dropyourbusiness.com/api/emp"
      );
      console.log(response);
      const employeeData = response.data.employees
        .filter((emp) => emp.employee_role === "M") // Filter only employees with role "M"
        .map((emp) => ({
          Employee_id: emp.employee_id,
          DeptName: emp.department?.department_name || "N/A", // Extract department name
          Country: emp.employee_country,
          State: emp.employee_state,
          City: emp.employee_city,
          FirstName: emp.employee_first_name,
          MiddleName: emp.employee_middle_name,
          LastName: emp.employee_last_name,
          Email: emp.employee_email,
          IsLastLogin: emp.employee_islastlogin,
          Address: emp.employee_address,
          Pincode: emp.employee_pincode,
          DateofJoin: emp.employee_dateofjoin,
          DateofLeave: emp.employee_dateofleave,
          IsActive: emp.employee_isactive,
          Gender: emp.employee_gender,
          Contact: emp.employee_contact,
          Profile: emp.employee_profile || "../images/imageicon.png", // Default image callback,
          File: emp.employee_attachfile,
          Role: emp.employee_role,
          EmpType: emp.employee_type,
        }));
      if (employeeData.length > 0) {
        setManagerProfile(employeeData[0].Profile); // Set first admin's profile as default
      }
      console.log("Filtered employees:", employeeData);
      setEmployees(employeeData);
      setFilteredManager(employeeData);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchEmployees();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const openModal = (employee = null) => {
    if (employee) {
      setFormData(employee);
      // setEditMode(true);
    } else {
      setFormData({
        employee_first_name: "",
        employee_middle_name: "",
        employee_last_name: "",
        employee_email: "",
        employee_password: "",
        employee_contact: "",
        employee_address: "",
        employee_pincode: "",
        employee_gender: "",
        employee_country: "",
        employee_state: "",
        employee_city: "",
        employee_dept_id: "",
        employee_islastlogin: "",
        employee_dateofjoin: "",
        employee_dateofleave: "",
        employee_isactive: true,
        employee_profile: "",
        employee_attachfile: "",
        employee_role: "M",
        employee_type: "",
        Employee_id: "",
      });
      setEditMode(false);
    }
    // Reset validation errors
    setErrors({});
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  //code for delete Employee
  const handleDelete = async (emp) => {
    const employee_id = emp.Employee_id;
    const employee_fullName = `${emp.FirstName || ""} ${emp.MiddleName || ""} ${
      emp.LastName || ""
    }`
      .trim()
      .replace(/\s+/g, " ");

    if (!employee_id) {
      toast.error("Invalid Employee ID. Please try again.");
      return;
    }

    // Set the employee full name and ID before showing the confirmation box
    setDeleteEmployeeName(employee_fullName);
    setDeleteEmployeeId(employee_id);
    setShowDeleteEmployeeBox(true); // Show the custom confirmation box
  };
  const confirmDeleteEmployee = async () => {
    if (!deleteEmployeeId) return;
    try {
      const response = await axios.delete(
        `https://aligndesk.dropyourbusiness.com/api/emp/delete/${deleteEmployeeId}`
      );
      if (response.status === 200) {
        toast.success("Manager deleted successfully!");
        const updatedEmployees = employees.filter(
          (item) => item.Employee_id !== deleteEmployeeId
        );
        setEmployees(updatedEmployees);
        setFilteredManager(updatedEmployees);
      }
      setShowDeleteEmployeeBox(false); // Close the confirmation box
    } catch (error) {
      console.error("Error deleting Employee:", error);
      toast.error("An error occurred while deleting the Employee.");
      setShowDeleteEmployeeBox(false); // Close the box on error
    }
  };

  const cancelDeleteEmployee = () => {
    setShowDeleteEmployeeBox(false); // Close the box
  };

  //confirmation for image
  const handleImageSelection = (
    Employee_id,
    FirstName,
    MiddleName,
    LastName,
    img
  ) => {
    if (!img) {
      toast.error("Please select an image.");
      return;
    }
    const fullName = `${FirstName} ${MiddleName} ${LastName}`.trim();
    console.log("Selected Employee:", fullName); // Debugging
    setSelectedImage(img);
    setSelectedEmployeeId(Employee_id);
    setSelectedEmployeeName(fullName);
    setIsUploadModalOpen(true); // Open confirmation modal
  };

  const confirmImageUpload = async () => {
    if (!selectedImage || !selectedEmployeeId) return;

    const formData = new FormData();
    formData.append("employee_image", selectedImage);
    setIsUploadModalOpen(false);
    setLoading(true);
    try {
      const response = await axios.post(
        `https://aligndesk.dropyourbusiness.com/api/emp/add-image/${selectedEmployeeId}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Image uploaded successfully!");
        fetchEmployees(); // Refresh employee data after upload
      } else {
        toast.error("Failed to upload image.");
      }
    } catch (error) {
      console.error("Image upload error:", error);
      toast.error("An error occurred while uploading the image.");
    }
    setIsUploadModalOpen(false); // Close the confirmation modal
    setSelectedImage(null);
    setSelectedEmployeeId(null);
    setSelectedEmployeeName("");
  };

  const cancelImageUpload = () => {
    setIsUploadModalOpen(false);
    setSelectedImage(null);
    setSelectedEmployeeId(null);
    setSelectedEmployeeName("");
  };

  const handleEdit = (manager) => {
    setFormData({
      employee_role: manager.Role,
      Employee_id: manager.Employee_id,
      employee_first_name: manager.FirstName || "",
      employee_middle_name: manager.MiddleName || "",
      employee_last_name: manager.LastName || "",
      employee_email: manager.Email || "",
      employee_contact: manager.Contact || "",
      employee_address: manager.Address || "",
      employee_pincode: manager.Pincode || "",
      employee_gender: manager.Gender || "",
      employee_country:
        country.find((c) => c.CountryName === manager.Country)?.CountryId || "",
      employee_state:
        state.find((s) => s.StateName === manager.State)?.StateId || "",
      employee_city:
        city.find((ct) => ct.CityName === manager.City)?.CityId || "",
      employee_dept_id:
        department.find((d) => d.DepartmentName === manager.DeptName)
          ?.DepartmentId || "",
      employee_dateofjoin: manager.DateofJoin || "",
      employee_dateofleave: manager.DateofLeave || "",
      // employee_profile:manager.Profile || "",
      employee_isactive: manager.IsActive || false,
      employee_type: manager.EmpType || "",
    });

    setEditMode(true); // Enable edit mode
    setIsModalOpen(true); // Open modal with pre-filled data
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation Logic
    const validateForm = () => {
      const newErrors = {};
      // const employee_confirm_password="";
      if (!formData.employee_first_name) {
        newErrors.employee_first_name = "First name is required.";
      }
      if (!formData.employee_last_name) {
        newErrors.employee_last_name = "Last name is required.";
      }
      if (!formData.employee_middle_name) {
        newErrors.employee_middle_name = "Middle name is required.";
      }
      if (!formData.employee_email) {
        newErrors.employee_email = "Email is required.";
      } else if (!/\S+@\S+\.\S+/.test(formData.employee_email)) {
        newErrors.employee_email = "Please enter a valid email address.";
      }
      // Check for duplicate email
      const emailExists = employees.some(
        (emp) => emp.Email === formData.employee_email
      );
      if (emailExists && !editMode) {
        toast.error("Email already exists!");
        return; // Stop form submission
      }
      if (!editMode && !formData.employee_password) {
        newErrors.employee_password = "Password is required.";
      } else if (!editMode && formData.employee_password.length < 6) {
        newErrors.employee_password = "Password must be at least 6 characters.";
      }
      if (!editMode && !formData.employee_confirm_password) {
        newErrors.employee_confirm_password = "Confirm Password is required.";
      } else if (
        !editMode &&
        formData.employee_confirm_password !== formData.employee_password
      ) {
        newErrors.employee_confirm_password =
          "Confirm Password must be same as Password";
      }
      if (!/^\d{10}$/.test(formData.employee_contact)) {
        newErrors.employee_contact = "Contact number must be 10 digits.";
      }
      if (!formData.employee_dept_id) {
        newErrors.employee_dept_id = "Please select a department.";
      }
      if (!formData.employee_type) {
        newErrors.employee_type = "employee type is required.";
      }
      if (!/^\d{6}$/.test(formData.employee_pincode)) {
        newErrors.employee_pincode = "Pincode must be 6 digits.";
      }
      return newErrors;
    };

    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    try {
      const url = editMode
        ? `https://aligndesk.dropyourbusiness.com/api/emp/update/${formData.Employee_id}`
        : "https://aligndesk.dropyourbusiness.com/api/emp/add";

      const method = editMode ? "put" : "post";
      await axios({
        method,
        url,
        data: formData,
      });
      toast.success(
        editMode
          ? "Manager updated successfully!"
          : "Manager added successfully!"
      );
      fetchEmployees(); // Refresh the table
      closeModal();
    } catch (error) {
      console.error("Error submitting data:", error);
      //Check if API returned "Email already exists"
      if (
        error.response &&
        error.response.data.message.includes("Email already exists")
      ) {
        toast.error("Email already exists!");
      } else {
        toast.error("Email already exists!");
      }
    }
  };

  // Table columns
  const columns = [
    { Header: "Sr.No", accessor: (row, index) => index + 1, id: "index" },
    {
      Header: "Profile",
      accessor: "Profile",
      Cell: ({ row }) => (
        <div>
          <label
            htmlFor={`file-upload-${row.original.Employee_id}`}
            style={{ cursor: "pointer" }}
          >
            <img
              src={row.original.Profile}
              alt="Profile"
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          </label>
          <input
            type="file"
            id={`file-upload-${row.original.Employee_id}`}
            style={{ display: "none" }}
            onChange={(e) =>
              handleImageSelection(
                row.original.Employee_id,
                row.original.FirstName,
                row.original.MiddleName,
                row.original.LastName,
                e.target.files[0]
              )
            }
          />
        </div>
      ),
    },
    {
      Header: "Name",
      accessor: (row) =>
        `${row.FirstName || ""} ${row.MiddleName || ""} ${
          row.LastName || ""
        }`.trim(),
      id: "FullName", // Provide a unique ID for the column
      className: "table-cell capitalize-text",
    },
    {
      Header: "Gender",
      accessor: "Gender",
      className: "table-cell capitalize-text",
    },
    {
      Header: "Email",
      accessor: "Email",
      className: "table-cell email-cell",
      Cell: ({ row }) => (
        <span className="email-cell">{row.original.Email.toLowerCase()}</span>
      ),
    },
    { Header: "Contact", accessor: "Contact", className: "table-cell" },
    {
      Header: "Address",
      accessor: "Address",
      className: "table-cell capitalize-text",
      Cell: ({ row }) => `${row.original.Address}, ${row.original.Pincode}`,
    },
    {
      Header: "City",
      accessor: "City",
      className: "table-cell capitalize-text",
    }, 
    {
      Header: "State",
      accessor: "State",
      className: "table-cell capitalize-text",
    },
    {
      Header: "Country",
      accessor: "Country",
      className: "table-cell capitalize-text",
    },
    {
      Header: "Designation",
      accessor: "EmpType",
      className: "table-cell capitalize-text",
    },
    {
      Header: "Department",
      accessor: "DeptName",
      className: "table-cell capitalize-text",
    },
    { Header: "DOJ", accessor: "DateofJoin", className: "table-cell" },
  ];

  //for upload image attachment in emp
  const handleImageUpload = async (Employee_id, img) => {
    if (!img) {
      toast.error("Please select a img.");
      return;
    }
    const formData = new FormData();
    formData.append("employee_image", img);
    try {
      const response = await axios.post(
        `https://aligndesk.dropyourbusiness.com/api/emp/add-image/${Employee_id}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Image uploaded successfully!");
        fetchEmployees(); // Refresh tasks after upload
      } else {
        toast.error("Failed to upload image.");
      }
    } catch (error) {
      console.error("Image upload error:", error);
      toast.error("An error occurred while uploading the image.");
    }
  };
  return (
    <div>
      <ToastContainer />
      {loading}
      <div
        className="page-head"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontSize: "10px",
          marginLeft: "1%",
          marginRight: "2%",
        }}
      >
        <h1>
          <FaUserTie /> Manager
        </h1>
        <button className="add-button" onClick={() => openModal()}>
          + Add
        </button>
      </div>
      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
          <p>Loading...</p>
        </div>
      ) : (
        <TableOne
          columns={columns}
          data={filteredManager.slice().reverse()}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
        />
      )}
      {showDeleteEmployeeBox && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <CiWarning /> Confirm Delete
            </div>
            <div className="popup-message">
              Are you sure you want to remove the manager{" "}
              <span className="employee-name">
                <strong>{deleteEmployeeName}</strong>
              </span>{" "}
              from the system?
            </div>
            <div className="popup-buttons">
              <button
                className="confirm-button"
                onClick={confirmDeleteEmployee}
              >
                Yes, Delete
              </button>
              <button className="cancel-button" onClick={cancelDeleteEmployee}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {/* // Upload Confirmation Modal for Employees */}
      <Modal
        isOpen={isUploadModalOpen}
        onRequestClose={cancelImageUpload}
        contentLabel="Confirm Upload"
        className="upload-confirmation-modal"
      >
        <h2>
          <CiWarning />
          Confirm Upload
        </h2>
        <p>
          Are you sure you want to upload a new profile picture for{" "}
          <strong>{selectedEmployeeName}</strong>?
        </p>
        <div className="form-actions">
          <button onClick={confirmImageUpload} className="confirm-button">
            Yes, Upload
          </button>
          <button onClick={cancelImageUpload} className="cancel-button">
            Cancel
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Manager Form"
        shouldCloseOnOverlayClick={false}
        className="add-manager-modal"
        // shouldCloseOnOverlayClick={false}
        style={{
          content: {
            width: "625px",
          },
        }}
      >
        <h2>{editMode ? "Edit Manager" : "Add Manager"}</h2>
        {/* <h2>{editMode ? "Edit Employee" : "Add Manager"}</h2> */}

        <form onSubmit={handleSubmit}>
          <div className="form-main">
            <div className="form-row">
              <TextField
                label="First Name"
                name="employee_first_name"
                value={formData.employee_first_name}
                error={!!errors.employee_first_name}
                helperText={errors.employee_first_name}
                onChange={handleInputChange}
                // disabled={editMode} // Disable when editing
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <FaUser />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Middle Name"
                name="employee_middle_name"
                value={formData.employee_middle_name}
                error={!!errors.employee_middle_name}
                helperText={errors.employee_middle_name}
                onChange={handleInputChange}
                // disabled={editMode} // Disable when editing
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <FaUser />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Last Name"
                name="employee_last_name"
                value={formData.employee_last_name}
                error={!!errors.employee_last_name}
                helperText={errors.employee_last_name}
                onChange={handleInputChange}
                // disabled={editMode} // Disable when editing
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <FaUser />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="form-row">
              <TextField
                label="Email"
                name="employee_email"
                value={formData.employee_email}
                error={!!errors.employee_email}
                helperText={errors.employee_email}
                // disabled={editMode} // Disable when editing
                onChange={handleInputChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <MdEmail />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Password"
                name="employee_password"
                value={formData.employee_password}
                error={!!errors.employee_password}
                helperText={errors.employee_password}
                onChange={handleInputChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <RiLockPasswordFill />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Confirm Password"
                name="employee_confirm_password"
                error={!!errors.employee_confirm_password}
                helperText={errors.employee_confirm_password}
                onChange={handleInputChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <RiLockPasswordFill />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="form-row" style={{ gap: "145px" }}>
              <div className="gender">
                <FormControl
                  style={{ display: "flex" }}
                  error={!!errors.employee_gender}
                >
                  <FormLabel id="demo-row-radio-buttons-group-label">
                    Gender
                    {errors.employee_gender && (
                      <FormHelperText>{errors.employee_gender}</FormHelperText>
                    )}
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={formData.employee_gender} // Bind value to formData
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        employee_gender: e.target.value,
                      })
                    } // Update formData on change
                  >
                    <FormControlLabel
                      value="male"
                      control={<Radio />}
                      label="Male"
                    />
                    <FormControlLabel
                      value="female"
                      control={<Radio />}
                      label="Female"
                    />
                    <FormControlLabel
                      value="other"
                      control={<Radio />}
                      label="Other"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="emp-contact">
                <TextField
                  label="Contact"
                  name="employee_contact"
                  value={formData.employee_contact}
                  error={!!errors.employee_contact}
                  helperText={errors.employee_contact}
                  onChange={handleInputChange}
                  fullWidth
                  style={{ marginLeft: "8px", width: "190px" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ color: "black" }}
                      >
                        <FaMobileRetro />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>
            <div className="form-row">
              <TextField
                select
                label="Department"
                name="employee_dept_id"
                value={formData.employee_dept_id}
                error={!!errors.employee_dept_id}
                helperText={errors.employee_dept_id}
                onChange={handleInputChange}
                fullWidth
                style={{ width: "190px" }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <SlOrganization />
                    </InputAdornment>
                  ),
                }}
              >
                {department.map((dept) => (
                  <MenuItem key={dept.DepartmentId} value={dept.DepartmentId}>
                    {dept.DepartmentName}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                label="Designation"
                name="employee_type"
                value={formData.employee_type}
                error={!!errors.employee_type}
                helperText={errors.employee_type}
                onChange={handleInputChange}
                fullWidth
                style={{ width: "195px" }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <MdBadge />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                type="date"
                label="Date Of Join"
                name="employee_dateofjoin"
                value={formData.employee_dateofjoin}
                error={!!errors.employee_dateofjoin}
                helperText={errors.employee_dateofjoin}
                onChange={handleInputChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
                style={{ width: "190px" }}
              />
            </div>
            <div className="form-row">
              <TextField
                select
                label="Country"
                name="employee_country"
                value={formData.employee_country}
                error={!!errors.employee_country}
                helperText={errors.employee_country}
                onChange={handleInputChange}
                fullWidth
                style={{ width: "190px" }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <GiWorld />
                    </InputAdornment>
                  ),
                }}
              >
                {country.map((countryData) => (
                  <MenuItem
                    key={countryData.CountryId}
                    value={countryData.CountryId}
                  >
                    {countryData.CountryName}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                select
                label="State"
                name="employee_state"
                value={formData.employee_state}
                error={!!errors.employee_state}
                helperText={errors.employee_state}
                onChange={handleInputChange}
                fullWidth
                style={{ width: "190px" }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <FaCity />
                    </InputAdornment>
                  ),
                }}
              >
                {state.map((stateData) => (
                  <MenuItem key={stateData.StateId} value={stateData.StateId}>
                    {stateData.StateName}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                select
                label="City"
                name="employee_city"
                value={formData.employee_city}
                error={!!errors.employee_city}
                helperText={errors.employee_city}
                onChange={handleInputChange}
                fullWidth
                style={{ width: "190px" }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <FaTreeCity />
                    </InputAdornment>
                  ),
                }}
                FaTreeCity
              >
                {city.map((cityData) => (
                  <MenuItem key={cityData.CityId} value={cityData.CityId}>
                    {cityData.CityName}
                  </MenuItem>
                ))}
              </TextField>
            </div>
            <div className="form-row">
              <TextField
                label="Residential Address"
                name="employee_address"
                id="outlined-textarea"
                value={formData.employee_address}
                error={!!errors.employee_address}
                helperText={errors.employee_address}
                onChange={handleInputChange}
                fullWidth
                style={{ width: "400px" }}
                multiline
                rows={1} // You can adjust the number of rows as needed
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <FaAddressCard />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Pincode"
                name="employee_pincode"
                value={formData.employee_pincode}
                error={!!errors.employee_pincode}
                helperText={errors.employee_pincode}
                onChange={handleInputChange}
                // fullWidth
                style={{ width: "190px", marginLeft: "5px" }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <TbMapPinCode />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </div>
          <div>
            <div className="all-button-form">
              <button type="submit" className="add-button">
                {editMode ? "Save" : "Add"}
              </button>
              <button type="button" onClick={closeModal} className="btn-cancel">
                Cancel
              </button>
            </div>
          </div>
        </form>
      </Modal>
    </div>
  );
};
export default Manager;
